'use client'

import { motion } from 'framer-motion'
import { usePostHog } from 'posthog-js/react'
import { useRef } from 'react'

export const ScrollContainer = ({ children }: { children: React.ReactNode }) => {
  const posthog = usePostHog()
  const hasTracked = useRef(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const calculateProgress = () => {
    const container = containerRef.current
    if (!container) return 0

    const section = container.closest('.snap-section')
    if (!section) return 0

    // Find the index of this section among all snap-sections
    const allSections = document.querySelectorAll('.snap-section')
    const sectionArray = Array.from(allSections)
    const index = sectionArray.indexOf(section)
    if (index === -1) return 0

    return Math.round((index / (sectionArray.length - 1)) * 100)
  }

  return (
    <motion.div
      ref={containerRef}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ margin: '-100px', once: false }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="w-full"
      onViewportEnter={() => {
        if (!hasTracked.current) {
          const progressPercentage = calculateProgress()

          posthog.capture('slide_viewed', {
            progress_percentage: progressPercentage,
            section_index:
              containerRef.current?.closest('.snap-section')?.getAttribute('data-section-index') ?? 'unknown',
          })

          hasTracked.current = true
        }
      }}
    >
      {children}
    </motion.div>
  )
}
